
// Extend Array interface to include the last property
interface Array<T> {
  last: T | undefined;
}